import React from 'react';
import { Lock, Shield, Network, ShieldAlert, ShieldCheck, Key } from 'lucide-react';

const iconMap = {
  lock: Lock,
  shield: Shield,
  network: Network,
  alert: ShieldAlert,
  check: ShieldCheck,
  key: Key
};

export function SecurityIcon({ name = 'shield', className = '', size = 24 }) {
  const IconComponent = iconMap[name] || Shield;
  
  return (
    <div className={`relative flex items-center justify-center ${className}`}>
      <IconComponent size={size} className="relative z-10" />
      {/* Subtle glow effect behind the icon */}
      <div className="absolute inset-0 bg-secondary/20 blur-md rounded-full z-0 scale-150"></div>
    </div>
  );
}

export default SecurityIcon;